import script from "./Section.vue?vue&type=script&lang=ts&setup=true"
export * from "./Section.vue?vue&type=script&lang=ts&setup=true"

import "./Section.vue?vue&type=style&index=0&id=a42c30b2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a42c30b2"]])

export default __exports__